import { CONTAINER_TRADEIN } from 'Constant';
import { createSelector, Selector } from 'reselect';
import { getIsTauschbonusEligible } from '../DeviceDetail/helpers/getIsTauschbonusEligible';
import { IInitialState } from './interfaces/state';
import { initialState } from './reducer';
import { RootState } from '@vfde-fe/sails_core';

const selectState = (state: RootState<IInitialState>) => state[CONTAINER_TRADEIN] || initialState;

const selectLoading = (): Selector<RootState<IInitialState>, IInitialState['loading']> =>
    createSelector(
        selectState,
        (state: IInitialState) => state.loading,
    );

const selectHasError = (): Selector<RootState<IInitialState>, IInitialState['hasError']> =>
    createSelector(
        selectState,
        (state: IInitialState) => state.hasError,
    );

const selectDevices = (): Selector<RootState<IInitialState>, Exclude<IInitialState['payload'], null>> =>
    createSelector(
        selectState,
        (state: IInitialState) => state.payload || [],
    );

const selectTradeIn = (): Selector<RootState<IInitialState>, boolean> =>
    createSelector(
        selectState,
        (state: IInitialState) => !!(state.tradeInSwitch && state.selectedDeviceId),
    );

const selectTauschbonus = (): Selector<RootState<IInitialState>, boolean> =>
    createSelector(
        selectState,
        (state: IInitialState) => !!(state.tradeInSwitch && state.selectedDeviceId && getIsTauschbonusEligible()),
);

const selectTradeInSwitch = (): Selector<RootState<IInitialState>, IInitialState['tradeInSwitch']> =>
    createSelector(
        selectState,
        (state: IInitialState) => state.tradeInSwitch,
    );

const selectSuggestFieldValue = (): Selector<RootState<IInitialState>, IInitialState['suggestFieldValue']> =>
    createSelector(
        selectState,
        (state: IInitialState) => state.suggestFieldValue,
    );

const selectSelectedDeviceId = (): Selector<RootState<IInitialState>, IInitialState['selectedDeviceId']> =>
    createSelector(
        selectState,
        (state: IInitialState) => state.selectedDeviceId,
    );

const selectIsDeviceNotFound = (): Selector<RootState<IInitialState>, boolean> =>
    createSelector(
        selectState,
        (state: IInitialState) => !!(state.payload && state.payload.length === 0),
    );

export {
    selectLoading,
    selectHasError,
    selectDevices,
    selectTradeIn,
    selectTradeInSwitch,
    selectSuggestFieldValue,
    selectSelectedDeviceId,
    selectIsDeviceNotFound,
    selectTauschbonus,
};
